import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Preload } from "../../components/Preload";
import { useAuth } from "../../hooks/useAuth";

export function SignoutAsUser() {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  useEffect(() => {
    signOut();
    navigate("/");
  }, [navigate, signOut]);

  return <Preload loading />;
}
